export default __webpack_public_path__ + "static/media/CIA-Privacy-Policy-03102025.7a027b78.pdf";